import type { ThunkDispatch } from 'editor/src/store/hooks';
import { setMockupDownloadingAction } from 'editor/src/store/mockup/slice';

const onMockupDownloadStarted = () => (dispatch: ThunkDispatch) => {
  dispatch(setMockupDownloadingAction(true));
};

export default onMockupDownloadStarted;
